// extracted by mini-css-extract-plugin
export default {"container":"HQ-z","topReviewHeading":"IQ-z","criticalReview":"JQ-z","favorableReview":"KQ-z","vsSeparator":"LQ-z"};